import type { ReactNode } from 'react';
import { Center, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconInbox, type Icon } from '@tabler/icons-react';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: Icon;
  /** call-to-action (e.g. a "Create" button) */
  action?: ReactNode;
  /** compact variant for panels / tables */
  compact?: boolean;
}

/**
 * Friendly empty / zero-data state.
 * @example <EmptyState title={t('common:states.empty')} action={<Button>…</Button>} />
 */
export function EmptyState({ title, description, icon: IconCmp = IconInbox, action, compact = false }: EmptyStateProps) {
  return (
    <Center py={compact ? 'md' : 'xl'}>
      <Stack align="center" gap="xs" maw={420} ta="center">
        <ThemeIcon size={compact ? 40 : 64} radius="xl" variant="light" color="gray">
          <IconCmp size={compact ? 22 : 34} aria-hidden />
        </ThemeIcon>
        <Title order={compact ? 5 : 4}>{title}</Title>
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
        {action}
      </Stack>
    </Center>
  );
}
